import {
  AccountInfo,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MSALConfig } from "auth/microsoft";
import { GlobalAlert } from "components";
import CommonDialog from "components/molecules/CommonDialog";
import { TimeHelper } from "helpers";
import "moment/locale/vi";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { RootReducer } from "redux/configurations/rootReducer";
import AppRouter from "routers";
import "utils/i18n/index";

const App = () => {
  const language = useSelector(
    (state: RootReducer) => state.LanguageReducer.language
  );

  const msalInstance = new PublicClientApplication(MSALConfig);

  useEffect(() => {
    TimeHelper.viInstallation();
    msalInstance.initialize().then(() => {
      msalInstance.addEventCallback((event: any) => {
        const account = event.payload.account as AccountInfo;
        if (event.eventType === EventType.LOGIN_SUCCESS && account) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
        }
      });
    });
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <LocalizationProvider
          dateAdapter={AdapterMoment}
          adapterLocale={language}
        >
          <HelmetProvider>
            <Helmet titleTemplate="%s - MSD" defaultTitle="MSD WMS">
              <meta name="description" content="Powered by SCSSolutions" />
            </Helmet>
          </HelmetProvider>
          <AppRouter />
          <GlobalAlert />
          <CommonDialog />
        </LocalizationProvider>
      </BrowserRouter>
    </MsalProvider>
  );
};
export default App;
